<!-- 集控器编辑框 -->
<template>
    <el-dialog :title="title" :visible.sync="visible" :append-to-body="true" :before-close="handleCloseDialog">
        <el-form :model="deviceForm" :rules="rules" ref="ruleForm" label-width="100px" :key="formKey">
            <el-form-item label="场景名称" prop="serverroom_map_name">
                <el-input v-model="deviceForm.serverroom_map_name"></el-input>
            </el-form-item>
            <el-form-item label="集控器" prop="terminal_id">
                <el-select v-model="deviceForm.terminal_id" placeholder="请选择活动区域">
                    <el-option
                        v-for="item in collectorList"
                        :key="item.oid"
                        :label="item.dev_name +' : '+ item.dev_serial"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="组态模板" v-if="!deviceForm.oid">
                <el-select v-model="deviceForm.mode" placeholder="请选择活动区域" @change="handleChange">
                    <el-option
                        v-for="item in mapTemplate"
                        :key="item.oid"
                        :label="item.template_name"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
import Storage from '@/utils/storage'
import { mapGetters } from "vuex";

const Params = { 
    serverroom_map_name: '', //场景名称
    terminal_id: '',    // plcID
    map_value_phone: '', //
    map_value_computer: '',
    assigned_project_id: '', //项目ID
}

export default {
    name: 'cmpSceneDialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        form: {
            type: Object,
            default: {}
        }
    },
    data () {
        return {
            dialogFormVisible: false,
            deviceForm: JSON.parse(JSON.stringify(Params)),
            rules: {
                serverroom_map_name: [{ required: true, message: '请输入场景名称', trigger: 'blur' }],
                terminal_id: [
                    { required: true, message: '请选择集控器', trigger: 'change' }
                ]
            },

            collectorList: [],
            mapTemplate: [],

            formKey: new Date().getTime()
        };
    },

    watch: {
        visible(newVal) {
            if(newVal) {
                this.handleInitData(this.form);
            }
        }
    },

    computed: {
        ...mapGetters(["machine"]),
        title() {
            return this.deviceForm.id ? "修改" : "新增";
        },
    },

    mounted() {
        setTimeout(() => {
            this.getList()
        }, 2000);
    },

    methods: {
        handleInitData(Val) {
            if(this.mapTemplate.length===0) {
                this.getModuleTemp()
            }
            if(JSON.stringify(Val) === "{}") return;
            if(Val.oid) {
                // 编辑
                this.deviceForm = Object.assign({}, Val);
            }
        },
        // 获取集控器列表
        async getList() {
            if(this.machine.collect.length>0) {
                this.collectorList = this.machine.collect;
                return
            }

            let data = await Service.getCollector();
            if(data){
                data = data === 'success' ? [] : data;
                this.collectorList = data;
                this.$store.dispatch('setCollect', data);
            }
        },
        async getModuleTemp() {
            let res = await Service.getConfigurationTemp()
            if(res != 'success' && res.length>0) {
                this.mapTemplate = res
            }
        },
        handleChange(val) {
            let obj = this.mapTemplate.filter(v=>{return v.oid === val})[0]
            if(obj) {
                this.deviceForm.map_value_computer = obj.map_value_computer
            }
        },
        // 关闭弹框
        handleCloseDialog() {
            this.deviceForm = JSON.parse(JSON.stringify(Params)),
            this.formKey = new Date().getTime()
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认关闭
        handleSave() {
            this.$refs['ruleForm'].validate(async (valid) => {
                if (valid) {
                    let res
                    this.deviceForm.map_type = 2
                    if(this.deviceForm.oid) {
                        // 修改
                        res = await Service.editMapServerroom(this.deviceForm)
                    }else {
                        // 新增
                        res = await Service.addSenceMap(this.deviceForm)
                    }
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                        });
                    }
                    this.$emit("handleCloseDialog", {flag: true, data: {}});
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
    }
}

</script>
<style lang='less' scoped>
</style>